import angular from 'angular';
import LinkedRetailersTableModule from './components/linked-retailers-table/linked-retailers-table-module';
import AccountRetailersComponent from './account-retailers-component';

export default angular
  .module('account-retailers', [
    LinkedRetailersTableModule.name,
  ])
  .component('accountRetailers', new AccountRetailersComponent());



// WEBPACK FOOTER //
// ./src/modules/user/components/edit-account/components/account-retailers/account-retailers-module.js